module.exports = __webpack_public_path__ + "img/海量货源.65657175.png";